import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getIsSyntheticTest} from 'modules/meta/selectors'
import {getSearchProgressPercentage} from 'modules/progressBar/selectors'
import {SearchProgressPercentage} from 'modules/progressBar/types'

import OpacityAnimation from '@vio/atlas/helpers/OpacityAnimation'
import {HorizontalProgressBar} from '@vio/atlas/HorizontalProgressBar'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const Wrapper = styled(OpacityAnimation)`
  will-change: opacity;
  width: 100%;
  ${linariaMq.desktopSm} {
    position: absolute;
  }

  &.--behind-tooltip {
    position: relative;
    z-index: -1;
  }
`

export const SearchProgressBar = ({
  mobileTooltipVisible = false
}: {
  mobileTooltipVisible?: boolean
}) => {
  const percentage = useSelector(getSearchProgressPercentage)
  const isSyntheticTest = useSelector(getIsSyntheticTest)
  const [isVisible, setIsVisible] = React.useState(true)

  useEffect(() => {
    const shouldDisplay =
      !isSyntheticTest &&
      percentage > 0 &&
      percentage < SearchProgressPercentage.SearchCompleted

    setIsVisible(shouldDisplay)
  }, [percentage, isSyntheticTest])

  return (
    <Wrapper
      className={mobileTooltipVisible && '--behind-tooltip'}
      delay={100}
      isVisible={isVisible}
      ignorePosition={true}
    >
      <HorizontalProgressBar
        value={percentage}
        colorPath="background.brand.primary"
        rounded={false}
      />
    </Wrapper>
  )
}
